<template>
  <!--   <div class="map">
    <MglMap
      :accessToken="accessToken"
      :mapStyle.sync="mapStyle"
      :center="newCoordinate"
      :zoom="zoom"
    >
      <MglMarker
        :coordinates.sync="newCoordinate"
        draggable
        @dragend="stateLocation(newCoordinate)"
      >
        <span slot="marker" class="mapboxgl-marker">
          <img src="@/assets/marker.png" alt="" />
        </span>
      </MglMarker>

      <MglNavigationControl position="bottom-right" />
    </MglMap>

    <div class="search-bar-wrapper">
      <div class="search-bar">
        <input class="input" type="text" value="" placeholder="Search Here" />
      </div>
    </div>

    <div class="btns-info">
      <span class="btn" @click="loadGPS()">{{ statusText }}</span>
      <span class="info"
        >Please drag the marker to pin your desired location.</span
      >
    </div>

    <div class="locsearch-container">
      <input
        v-on:input="onInput"
        v-on:keyup.enter="searchLocation"
        v-model="locationSearchText"
        class="search-field"
        placeholder="Search"
      />
      <div class="icon-wrapper" @click="searchLocation">
        <a-icon type="search" class="button-icon" v-show="!isSearching" />
        <a-icon type="loading" class="button-icon" v-show="isSearching" />
      </div>
    </div>

    <div
      class="locquery-container"
      v-show="showSearchSuggestions && locationSearchText"
    >
      <div
        class="locquery-items"
        v-for="response in searchResponse"
        :key="response.id"
      >
        <div @click="handleSearchResponse(response)">
          {{ response.place_name }}
        </div>
      </div>
    </div>

    <WizardFooter />
  </div> -->

  <div>
    <nav class="breadcrumb">
      <ul>
        <li><a @click.prevent="handleBreadcumb0()">Cart</a></li>
        <li>
          <a @click.prevent="handleBreadcumb1()" class="active">Location</a>
        </li>
        <li><a @click.prevent="handleBreadcumb1()">Delivery</a></li>
        <li><a @click.prevent="handleBreadcumb1()">Payment</a></li>
      </ul>
    </nav>
    <!-- <p>{{ getPromoInfo }}</p> -->
    <main>
      <div class="main-left">
        <div class="delivery-location">
          <p class="title">Delivery Location</p>
          <p>
            <span class="btn" @click="loadGPS()">{{ statusText }}</span>
          </p>
          <p class="instruction">
            Please Drag the Marker to Pin your desired Location.
          </p>

          <div class="locSearch">
            <div class="locsearch-container">
              <input
                v-on:input="onInput"
                v-on:keyup.enter="searchLocation"
                v-model="locationSearchText"
                class="search-field"
                placeholder="Search"
              />
              <div class="icon-wrapper" @click="searchLocation">
                <a-icon
                  type="search"
                  class="button-icon"
                  v-show="!isSearching"
                />
                <a-icon
                  type="loading"
                  class="button-icon"
                  v-show="isSearching"
                />
              </div>
            </div>

            <div
              class="locquery-container"
              v-show="showSearchSuggestions && locationSearchText"
            >
              <div
                class="locquery-items"
                v-for="response in searchResponse"
                :key="response.id"
              >
                <div @click="handleSearchResponse(response)">
                  {{ response.place_name }}
                </div>
              </div>
            </div>
          </div>

          <MglMap
            :accessToken="accessToken"
            :mapStyle.sync="mapStyle"
            :center="newCoordinate"
            :zoom="zoom"
          >
            <MglMarker
              :coordinates.sync="newCoordinate"
              draggable
              @dragend="stateLocation(newCoordinate)"
            >
              <span slot="marker" class="mapboxgl-marker">
                <img src="@/assets/marker.png" alt="" />
              </span>
            </MglMarker>

            <MglNavigationControl position="bottom-right" />
          </MglMap>
        </div>
      </div>
      <div class="main-right">
        <div class="order-summary">
          <p class="title">Order Summary</p>
          <div class="items-list">
            <div class="item" v-for="item in cartItems" :key="item.id">
              <div class="item-left">
                <img
                  v-if="!item.image"
                  class="cartListImg"
                  src="../../../assets/images/default-img.jpg"
                />

                <img
                  v-else
                  class="cartListImg"
                  :src="item.image"
                  :alt="item.name"
                />
              </div>
              <div class="item-right">
                <div class="item-name">
                  {{ item.name }}
                </div>
                <div class="item-qty">
                  NRs. {{ item.after_price }} X {{ item.quantity }}
                </div>
              </div>
            </div>
          </div>
          <div class="calculations">
            <p>Subtotal ({{ cartQuantity }} items)</p>
            <p>NRs. {{ this.cartTotal }}</p>
          </div>
          <!-- <div class="coupon-code">
            <button class="discount">
              <div class="discount-details-wrapper">
                <div class="discounts-info">
                  <span
                    v-if="
                      this.getPromoInfo.description ||
                      this.getPromoInfo.cookedFood ||
                      this.getPromoInfo.mart ||
                      this.getPromoInfo.bakery ||
                      this.getPromoInfo.liquor ||
                      this.getPromoInfo.deliveryCharge
                    "
                    class="discounts-header"
                    >Coupon Discount Applied!</span
                  >
                  <span v-if="this.getPromoInfo.description">
                    {{ this.getPromoInfo.description }}
                  </span>
                  <span v-if="this.getPromoInfo.cookedFood > 0">
                    {{ this.getPromoInfo.cookedFood }}% Discount in Food Items.
                  </span>
                  <span v-if="this.getPromoInfo.mart > 0">
                    {{ this.getPromoInfo.mart }}% Discount in Mart Items.
                  </span>
                  <span v-if="this.getPromoInfo.bakery > 0">
                    {{ this.getPromoInfo.bakery }}% Discount in Bakery Items.
                  </span>
                  <span v-if="this.getPromoInfo.liquor > 0">
                    {{ this.getPromoInfo.liquor }}% Discount in Liquor Items.
                  </span>
                  <span v-if="this.getPromoInfo.deliveryCharge >= 0"
                    >Delivery Charge Rs
                    {{ this.getPromoInfo.deliveryCharge }}.</span
                  >
                </div>
              </div>
            </button>
          </div> -->

          <!-- <div
            class="category-price-container calculations"
            v-if="this.getPromoInfo.status === true"
          >
            <p class="category-text">Discount:</p>
            <div>
              <p class="category-price">
                NRs. {{ this.cartTotal - this.getPromoDiscountTotal }}
              </p>
            </div>
          </div> -->

          <div class="calculations">
            <p class="calculations__cartTotal">
              <span>++ Delivery Charge </span>
            </p>
            <!-- <p class="calculations__cartTotal">NRs. {{ this.delCharge }}</p> -->
          </div>

          <div
            class="category-price-container calculations"
            v-if="this.vat !== 0"
          >
            <p class="category-text">VAT(13%):</p>
            <p class="category-price">NRs. {{ this.vat }}</p>
          </div>

          <div
            class="category-price-container calculations"
            v-if="this.intlTransfer !== 0"
          >
            <p class="category-text">International Transfer Charge(5.1%):</p>
            <p class="category-price">NRs. {{ this.intlTransfer }}</p>
          </div>

          <!-- <div class="total-price-container calculations">
            <p class="total-price">Total Amount:</p>

comment
            <p class="total-price">
              NRs.
              {{
                (this.getPromoDiscountTotal === 0
                  ? this.cartTotal
                  : this.getPromoDiscountTotal) +
                this.delCharge +
                this.vat +
                this.intlTransfer
              }}
            </p>

            comment
            <p class="total-price">
              NRS. {{ this.cartTotal + this.delCharge }}
            </p>
          </div> -->

          <div class="message-wrapper">
            <!-- <div class="message-text" v-if="!this.gotLocationError">
              Delivery Charge of
              <span class="delivery-charge">Rs.{{ this.delCharge }} </span>
              will be added based on your provided location.
            </div> -->

            <div class="message-text" v-if="this.gotLocationError">
              {{ this.errorMessage }}
            </div>
          </div>
        </div>
        <div class="buttons">
          <a
            ><button @click.prevent="handleContinueShopping()">
              <a-icon type="shopping-cart" />ADD MORE ITEMS
            </button></a
          >
          <a>
            <button @click.prevent="handleCheckout()">CONFIRM LOCATION</button>
          </a>
        </div>
      </div>
    </main>
    <!-- <WizardFooter /> -->
  </div>
</template>

<script>
import { MglMap, MglMarker, MglNavigationControl } from "vue-mapbox";
import { LocationId, CartData } from "../../../services/storage.service";
import "mapbox-gl/dist/mapbox-gl.css";
import { mapGetters, mapActions } from "vuex";
import WizardFooter from "../../../components/FloatingFooter/WizardFooter";
import axios from "axios";
import router from "../../../router";
import { UserService } from "../../../services/user.service";

export default {
  name: "CheckoutMap",
  components: {
    MglMap,
    MglMarker,
    MglNavigationControl,
    WizardFooter,
  },
  data() {
    return {
      defaultCoordinate: [85.3149862, 27.6793441],
      newCoordinate: [0, 0],
      showSearchSuggestions: false,
      statusText: "Loading GPS",
      accessToken:
        "pk.eyJ1Ijoia2hhYW5waW4iLCJhIjoiY2p5ZXI5c2FwMDNsMzNobzdkaWgyNnB1MSJ9.VJFEMcSTKXmER7VTW_p4Fg",
      mapStyle: "mapbox://styles/mapbox/light-v10",
      zoom: 15,
      locationSearchText: "",
      isSearching: false,
      searchResponse: [],
      display: "none",
      cartQuantity: 0,
      coupon: "",
      showCouponForm: false,
      promoInfo: {},
      delCharge: 0,
      gotLocationError: true,
      errorMessage: "",
      height: 0,
      newTotal: 0,
      intlTransfer: 0,
      vat: 0,
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.loadGPS();

    if (LocationId.getLocationId() == 1) {
      this.newCoordinate = [85.3149862, 27.6793441];
    } else if (LocationId.getLocationId() == 2) {
      this.newCoordinate = [83.9753518, 28.2128931];
    }

    let quantity = this.cartItems.reduce((acc, item) => acc + item.quantity, 0);
    this.cartQuantity = quantity;
  },
  computed: {
    ...mapGetters([
      "cartItems",
      "cartTotal",
      "getPromoDiscountTotal",
      "getPromoDiscount",
      "systemStaticTexts",
      "getPromoInfo",
      "cartItems",
    ]),
  },
  methods: {
    ...mapActions([
      "markerChange",
      "updateStep",
      "addDiscount",
      "addCFDiscount",
      "addMDiscount",
      "addBDiscount",
      "addLDiscount",
      "addPromoCode",
      "applyDeliveryCharge",
      "setPromoInfo",
    ]),

    stateLocation: function(coord) {
      if (
        this.defaultCoordinate[0] == coord[1] ||
        this.defaultCoordinate[1] == coord[0]
      ) {
        this.$message.warning(
          "Some Issue With Location, Please Enable GPS or Select a location in Map"
        );
      } else {
        let a = [coord[1], coord[0]];
        this.markerChange(a);
      }
    },

    handleSearchResponse(response) {
      this.newCoordinate = response.center;
      this.locationSearchText = response.place_name;
      this.showSearchSuggestions = false;
      this.stateLocation(response.center);
    },

    onInput() {
      if (this.locationSearchText.length > 3) {
        this.searchLocation();
      }
    },

    searchLocation() {
      this.isSearching = true;
      axios
        .get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.locationSearchText}.json?country=np&access_token=${this.accessToken}`
        )
        .then((response) => {
          this.searchResponse = response.data.features;
          if (response.data.features) {
            this.showSearchSuggestions = true;
          }
          this.isSearching = false;
        })
        .catch((error) => {
          this.isSearching = false;
          console.log("error", error);
        });
    },

    loadGPS: function() {
      this.statusText = "Accessing GPS...";

      navigator.geolocation.getCurrentPosition((position) => {
        this.newCoordinate = [
          Number(position.coords.longitude),
          Number(position.coords.latitude),
        ];
        this.statusText = "Pin My Current Location";
        this.stateLocation(this.newCoordinate);
      });
    },
    handleContinueShopping() {
      router.push("/:loc?");
    },

    handleCheckout() {
      // alert('clicked');

      // console.log("defaultCoordinate", this.defaultCoordinate);
      // console.log("newCoordinate", this.newCoordinate);
      if (this.defaultCoordinate[0] == this.newCoordinate[0]) {
        this.$message.warning(
          `Some Issue With Location, Please Enable GPS or Select a location in Map.`
        );
      } else {
        this.updateStep(2);
      }

      // if (this.cartTotal < 500) {
      //   this.$message.warning(`"Cart should be atleast of NRs. 500."`);
      // } else {
      //   this.updateStep(2);
      // }
    },
    handleBreadcumb0() {
      this.updateStep(0);
      this.setPromoInfo(this.promoInfo);
      // window.location.reload();
    },
    handleBreadcumb1() {
      this.updateStep(1);
    },

    handleCouponForm() {
      // console.log("show coupon code");
      this.showCouponForm = !this.showCouponForm;
      // console.log("showCouponForm", this.showCouponForm);
    },

    // sendPromo(e) {
    //   e.preventDefault();

    //   this.addPromoCode(this.coupon);

    //   UserService.promoSend(this.coupon)
    //     .then((data) => {
    //       const DATA = data.data;

    //       if (data.error === false) {
    //         this.promoInfo.status = true;
    //         this.promoInfo.description = DATA.description;

    //         this.promoInfo.deliveryCharge = DATA.delivery_charge;

    //         this.promoInfo.cookedFood = DATA.cooked_food;
    //         this.promoInfo.mart = DATA.mart;
    //         this.promoInfo.bakery = DATA.bakery;
    //         this.promoInfo.liquor = DATA.liquor;

    //         this.addCFDiscount(DATA.cooked_food);
    //         this.addMDiscount(DATA.mart);
    //         this.addBDiscount(DATA.bakery);
    //         this.addLDiscount(DATA.liquor);

    //         if (DATA.delivery_charge >= 0) {
    //           CartData.setDeliveryCharge(DATA.delivery_charge);
    //           this.applyDeliveryCharge(DATA.delivery_charge);
    //           this.delCharge = DATA.delivery_charge;
    //         }

    //         this.getCartItemsCategories(e);
    //       } else {
    //         this.$notification.error({
    //           message: "Promo Code is not valid",
    //           description: "Please confirm your promo code as it is not valid.",
    //         });
    //       }
    //     })
    //     .catch((err) => console.log(err));
    // },

    // getCartItemsCategories(e) {
    //   e.preventDefault();

    //   // cart items
    //   const cData = CartData.getCartItems();

    //   // adding item section
    //   let cartCat = cData.map((obj) => {
    //     const index = this.allItems.findIndex((el) => el["id"] == obj["id"]);
    //     const { section } = index !== 1 ? this.allItems[index] : {};

    //     return {
    //       ...obj,
    //       section,
    //     };
    //   });
    //   console.log("cartCat :" + cartCat);

    //   // group items according to category
    //   const groupCategories = cartCat.reduce((acc, cV) => {
    //     acc[cV.section] = acc[cV.section] || [];
    //     acc[cV.section].push(cV);
    //     return acc;
    //   }, Object.create(null));

    //   // calculate category total
    //   let totalObj = this.getCatTotal(groupCategories);

    //   // adding category discount %
    //   let discountObj = this.createDiscountObj();

    //   // merging two datasets
    //   let mergedObj = totalObj.map((item) => ({
    //     ...item,
    //     ...discountObj.find((innerItem) => innerItem.cat === item.cat),
    //   }));

    //   /* calculate cart total
    //     returns total if dis is empty
    //     returns discounted total if dis available
    //   */
    //   const catTotal = mergedObj.reduce(
    //     (sum, { cat_total, dis }) => sum + this.calcCatDiscount(cat_total, dis),
    //     0
    //   );

    //   this.newTotal = catTotal;
    //   this.addDiscount(catTotal);
    //   console.log("new total" + newTotal);
    // },

    async getItems() {
      let allData = [];
      let morePagesAvailable = true;
      let currentPage = 0;

      while (morePagesAvailable) {
        currentPage++;
        const response = await axios.post(
          // "https://manager.khaanpin.com/api/getitemsv2/",
          "https://deus.khaanpin.com/om/getitemsv2/",

          {
            loc_id: LocationId.getLocationId(),
            page: currentPage,
          }
        );

        let { data, page_count } = response.data;
        data.forEach((e) => allData.push(e));
        morePagesAvailable = currentPage < page_count;
      }

      const result = allData.map((data) => ({
        id: data.id,
        section: data.section,
      }));

      this.allItems = result;
    },

    // createDiscountObj() {
    //   let disObj = [];

    //   disObj.push(
    //     { cat: "cooked-food", dis: this.promoInfo.cookedFood },
    //     { cat: "mart", dis: this.promoInfo.mart },
    //     { cat: "bakery", dis: this.promoInfo.bakery },
    //     { cat: "drinks", dis: this.promoInfo.liquor }
    //   );

    //   return disObj;
    // },

    // calcCatDiscount(total, discount) {
    //   // console.log(total, discount);
    //   const discountedPrice = Math.ceil(total - (discount / 100) * total);
    //   return discountedPrice;
    // },

    getDeliveryCharge() {
      let coordinates = [this.newCoordinate[1], this.newCoordinate[0]];

      // const url = "https://manager.khaanpin.com/apiv2/getdeliverycharge/";
      const url = "https://deus.khaanpin.com/appapi/getdeliverycharge/";


      axios
        .post(url, {
          loc_id: LocationId.getLocationId(),
          location: "https://www.google.com/maps/place/" + coordinates,
        })
        .then((response) => {
          if (response.data.error === true) {
            this.gotLocationError = true;
            this.errorMessage = response.data.data;
            this.loading = false;
          } else {
            this.gotLocationError = false;
            CartData.setDeliveryCharge(response.data.data);
            this.applyDeliveryCharge(response.data.data);
            this.delCharge = response.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.gotError = true;
          this.loading = false;
        });
    },
  },
  watch: {
    cartItems: function(val) {
      let quantity = val.reduce((acc, item) => acc + item.quantity, 0);
      this.cartQuantity = quantity;
    },
    getPromoDiscount: function(newDiscount, oldDiscount) {
      if (newDiscount > 0) {
        this.showDiscount = true;
      } else {
        this.showDiscount = false;
      }
    },
    newCoordinate: function() {
      this.getDeliveryCharge();
    },
  },
  beforeMount() {
    // this.getUserRegion();
    this.getItems();
    this.getUserTimezone();
    this.getDeliveryCharge();
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

// new css
// variables
$theme-color: #ed3c3b;
$font-color: #706b6b;
$detail-color: #333;
$success-color: #60b246;
$info-color: #2e89d3;

$button-size: 16px;
$text-size: 16px;
$icon-size: 20px;
$heading-size: 24px;
$display-size: 36px;

$border: 1px solid rgba(3, 3, 3, 0.3);
$border-radius: 10px;

nav {
  max-width: 60rem;
  margin: 0px auto 20px;
  ul {
    list-style: none;
    li {
      display: inline;
      + li:before {
        content: ">";
        padding: 10px;
      }
      a {
        text-decoration: none;
        color: $font-color;
        font-size: $icon-size;
        text-transform: uppercase;
        color: $font-color;
        padding: 5px 10px;
        &:hover {
          opacity: 0.8;
          transition: all ease-in-out 0.3s;
        }
      }
      .active {
        color: $theme-color;
        font-weight: bold;
      }
    }
  }
}
main {
  width: 60rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 0.6fr;
  grid-gap: 20px;
  hr {
    opacity: 0.3;
  }
  p {
    font-size: $text-size;
    color: $detail-color;
  }
  .main-left {
    .delivery-location {
      margin-bottom: 80px;
      border-radius: $border-radius;
      padding: 20px;
      width: auto;
      height: 650px;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      overflow-y: scroll;
      .title {
        font-size: $heading-size;
        font-weight: bold;
        color: $detail-color;
        margin-bottom: 20px;
      }
      .instruction {
        font-size: 14px;
        font-weight: 400;
        color: $detail-color;
        margin-bottom: 20px;
      }
      p {
        span {
          background-color: $success-color;
          padding: 5px 10px;
          color: #fff;
          font-weight: bold;
          border-radius: $border-radius;
          border: $border;
          margin-right: 5px;
          box-shadow: 1px 1px 4px rgba(3, 3, 3, 0.3);
          &:hover {
            cursor: pointer;
            box-shadow: none;
          }
        }
      }
      .mgl-map-wrapper {
        height: 80%;
      }
      .locSearch {
        position: relative;
        width: 100%;
        background: #60b246;
        .locsearch-container {
          position: absolute;
          top: 5px;
          left: 5px;
          z-index: 5;

          background: #ffffff;
          height: 40px;
          // width: 100%;
          margin-bottom: 10px;
          border-radius: 10px;
          box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
            rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
          display: flex;

          .icon-wrapper {
            width: 15%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            outline: none;
            border: none;
          }
          .button-icon {
            pointer-events: none;
            color: #27272f;
            font-size: 17px;
          }

          .search-field {
            width: 85%;
            height: 100%;
            outline: none;
            border: none;
            border-radius: 10px;
            padding: 0px 10px;
          }
        }
        .locquery-container {
          position: absolute;
          top: 50px;
          // left: 20px;
          z-index: 5;
          background: #ffffff;
          max-height: 150px;
          height: "auto";
          width: 100%;
          border-radius: 10px;
          box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
            rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
          display: flex;
          flex-direction: column;
          overflow: scroll;

          .locquery-items {
            margin: 5px 10px;
            color: #27272f;
            padding-bottom: 5px;
            border-bottom: 1px solid lightgray;
          }
        }
      }
    }
  }

  .main-right {
    .order-summary {
      border-radius: $border-radius;
      width: auto;
      padding: 20px 20px 8px;

      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      .title {
        font-size: $heading-size;
        color: $detail-color;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .items-list {
        height: 9rem;
        padding: 0 10px;
        margin-bottom: 10px;
        border: $border;
        border-radius: $border-radius;
        overflow-y: hidden;
        &:hover {
          overflow-y: scroll;
        }
        .item {
          display: flex;
          margin: 20px 0 10px;
          .item-left {
            img {
              height: 50px;
              width: 50px;
              border-radius: $border-radius;
              box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
            }
          }
          .item-right {
            margin-left: 20px;
            .item-name {
              font-size: $text-size;
              font-weight: bold;
            }
          }
        }
      }
      .calculations {
        display: flex;
        justify-content: space-between;
      }

      .calculations__cartTotal {
        // border: 1px solid black;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        font-size: 12px;
        color: #646464;
      }

      .discount {
        width: 100%;
        outline: none;
        border: none;
        color: $detail-color;
        margin-bottom: 10px;

        &:hover {
          cursor: default;
        }
        li {
          list-style: none;
        }
        span {
          display: block;
        }
        .discounts-header {
          padding: 10px 0;

          text-decoration: underline;
        }
        .discounts-info {
          // height: 0;
          // padding: 10px;
          // margin-bottom: 10px;
          font-size: $button-size;
          font-weight: bold;
          background-color: #ffff00;
        }
      }
    }
    .buttons {
      padding: 20px;
      margin-top: 20px;
      margin-bottom: 80px;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      border-radius: $border-radius;
      display: flex;
      flex-flow: column nowrap;
      a {
        &:not(:last-child) {
          margin-bottom: 20px;
        }
        &:last-child {
          button {
            background-color: $success-color;
            color: #fff;
          }
        }
        button {
          padding: 10px;
          width: 100%;
          font-size: $button-size;
          border-radius: $border-radius;
          border: $border;
          outline: none;
          color: $font-color;
          background-color: white;
          box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
          i {
            font-size: 20px;
            margin-right: 5px;
          }
          &:hover {
            cursor: pointer;
            transition: all ease-in-out 0.3s;
            box-shadow: none;
          }
        }
      }
    }
  }

  // .main-right {
  //   .order-summary {
  //     border-radius: $border-radius;
  //     width: auto;
  //     padding: 20px;

  //     box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
  //     .title {
  //       font-size: $heading-size;
  //       color: $detail-color;
  //       font-weight: bold;
  //       margin-bottom: 10px;
  //     }
  //     .items-list {
  //       height: 9rem;
  //       padding: 0 10px;
  //       margin-bottom: 10px;
  //       border: $border;
  //       border-radius: $border-radius;
  //       overflow-y: hidden;
  //       &:hover {
  //         overflow-y: scroll;
  //       }
  //       .item {
  //         display: flex;
  //         margin: 20px 0 10px;
  //         .item-left {
  //           img {
  //             height: 50px;
  //             width: 50px;
  //             border-radius: $border-radius;
  //             box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  //           }
  //         }
  //         .item-right {
  //           margin-left: 20px;
  //           .item-name {
  //             font-size: $text-size;
  //             font-weight: bold;
  //           }
  //         }
  //         .calculations {
  //           display: flex;
  //           justify-content: space-between;
  //         }
  //       }
  //     }
  //     /*       .coupon-code {
  //       p {
  //         text-align: right;
  //         margin: 10px 0;
  //         color: $detail-color;
  //         text-decoration: underline;
  //         &:hover {
  //           cursor: pointer;
  //         }
  //       }
  //       .couponCode {
  //         // background-color: rebeccapurple;
  //         display: flex;
  //         justify-content: space-between;
  //         margin-bottom: 10px;
  //         input {
  //           flex-basis: 85%;
  //           outline: none;
  //           border: $border;
  //           padding: 10px;
  //           border-radius: $border-radius 0 0 $border-radius;
  //         }
  //         button {
  //           padding: 10px 20px;
  //           background-color: $success-color;
  //           outline: none;
  //           border: $border;
  //           color: #fff;
  //           border-radius: 0 $border-radius $border-radius 0;
  //           &:hover {
  //             opacity: 0.8;
  //             transition: all ease-in-out 0.3s;
  //           }
  //         }
  //       }
  //     } */

  //     /*       .promo-button {
  //       align-self: center;
  //       font-size: 16px;
  //       outline: none;
  //       color: #fff;
  //       border: none;
  //       cursor: pointer;
  //       padding: 5px 10px;
  //       border-radius: 5px;
  //       background-color: #1e90ff;
  //     }

  //     .promo-button:hover {
  //       box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  //     }

  //     .promo-form {
  //       display: flex;
  //       align-items: center;
  //       justify-content: center;
  //       font-family: $main-font;
  //       margin-top: 10px;

  //       .promo-input {
  //         height: 32px;
  //         border-radius: 5px;
  //         border: 1px solid $text-color2;
  //         outline: none;
  //         padding-left: 5px;
  //         color: $text-color;
  //         margin-right: 5px;
  //         font-weight: 400;
  //         font-size: 12px;
  //         line-height: 18px;
  //         width: 30%;
  //       }

  //       .promo-input:hover {
  //         border: 1px solid #1e90ff;
  //       }

  //       .promo-submit-btn {
  //         text-align: center;
  //         height: 32px;
  //         padding: 0px 5px;
  //         border-radius: 5px;
  //         background-color: #1e90ff;
  //         border: 1px solid #1e90ff;
  //         color: #fff;
  //         cursor: pointer;
  //         font-size: 13px;
  //         outline: none;
  //       }

  //       .promo-submit-btn:hover {
  //         border: 1px solid gray;
  //         background-color: #fff;
  //         color: gray;
  //       }
  //     }

  //     .coupon-code {
  //       margin-bottom: 10px;
  //       button {
  //         width: 100%;
  //       }
  //       form {
  //         display: flex;
  //         justify-content: center;
  //         align-items: center;
  //         input[type="varchar"] {
  //           flex: 1 1 auto;
  //         }
  //         input[type="submit"] {
  //           padding: 0 20px;
  //         }
  //       }
  //     } */

  //     .discount {
  //       width: 100%;
  //       outline: none;
  //       border: none;
  //       color: $detail-color;
  //       margin-bottom: 10px;
  //       &:hover {
  //         cursor: default;
  //       }
  //       li {
  //         list-style: none;
  //       }
  //       span {
  //         display: block;
  //       }
  //       .discounts-header {
  //         padding: 10px 0;

  //         text-decoration: underline;
  //       }
  //       .discounts-info {
  //         // height: 0;
  //         // padding: 10px;
  //         // margin-bottom: 10px;
  //         font-size: $button-size;
  //         font-weight: bold;
  //         background-color: #ffff00;
  //       }
  //     }
  //   }
  //   .buttons {
  //     padding: 20px;
  //     margin-top: 20px;
  //     margin-bottom: 60px;
  //     box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
  //     border-radius: $border-radius;
  //     display: flex;
  //     flex-flow: column nowrap;
  //     a {
  //       &:not(:last-child) {
  //         margin-bottom: 20px;
  //       }
  //       &:last-child {
  //         button {
  //           background-color: $success-color;
  //           color: #fff;
  //         }
  //       }
  //       button {
  //         padding: 10px;
  //         width: 100%;
  //         font-size: $button-size;
  //         border-radius: $border-radius;
  //         border: $border;
  //         outline: none;
  //         color: $font-color;
  //         background-color: white;
  //         box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  //         i {
  //           font-size: 20px;
  //           margin-right: 5px;
  //         }
  //         &:hover {
  //           cursor: pointer;
  //           transition: all ease-in-out 0.3s;
  //           box-shadow: none;
  //         }
  //       }
  //     }
  //   }
  // }
}

@media screen and (max-width: 1024px) {
  .breadcrumb {
    max-width: 50rem;
    margin: 0px auto 20px;
  }
  main {
    max-width: 50rem;
  }
}
@media screen and (max-width: 1225px) {
  .breadcrumb {
    max-width: 35rem;
    margin: 0px auto 20px;
  }
  main {
    max-width: 35rem;
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 725px) {
  .breadcrumb {
    margin-left: 20px;
    ul {
      li {
        + li:before {
          padding: 2px;
        }
        a {
          padding: 5px;
          font-size: calc(var(--icon-size) - 4px);
        }
      }
    }
  }
  main {
    width: 90vw;
    margin: 0 auto;
    .main-left {
      .delivery-location {
        width: 90vw;
        height: 430px;
      }
    }
  }
}

// old css
.map {
  width: 100%;
  height: 100%;
  position: relative;
}
.mapboxgl-marker {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
  transform: translate(0, -100%);
}

/* .locsearch-container {
  position: absolute;
  top: 60px;
  left: 20px;
  background: #ffffff;
  height: 40px;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  display: flex;

  .icon-wrapper {
    width: 15%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    border: none;
  }
  .button-icon {
    pointer-events: none;
    color: #27272f;
    font-size: 17px;
  }

  .search-field {
    width: 85%;
    height: 100%;
    outline: none;
    border: none;
    border-radius: 10px;
    padding: 0px 10px;
  }
} */

/* .locquery-container {
  position: absolute;
  top: 105px;
  left: 20px;
  background: #ffffff;
  max-height: 150px;
  height: "auto";
  width: 40%;
  border-radius: 10px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  display: flex;
  flex-direction: column;
  overflow: scroll;

  .locquery-items {
    margin: 5px 10px;
    color: #27272f;
    padding-bottom: 5px;
    border-bottom: 1px solid lightgray;
  }
} */

.btns-info {
  position: absolute;
  width: 100%;
  z-index: 99;
  top: 0px;
  background: rgba(0, 0, 0, 0.7);
  padding: 5px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: $main-font;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  .btn {
    cursor: pointer;
    background: rgb(91, 148, 0);
    padding: 5px;
    border: 3px solid #ccc;
    color: #fff;
    border-radius: 11px;
    text-transform: uppercase;
    font-weight: bold;
    float: left;
  }
  .info {
    float: left;
    margin-left: 10px;
    text-align: left;
    color: #fff;
    width: auto;
  }
}
.search-bar-wrapper {
  position: absolute;
  top: 50px;
  z-index: 99;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: $main-font;
  .search-bar {
    height: auto;
    width: 85%;
    background: #fff;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  }
  .input {
    width: 95%;
    height: 28px;
    border: none;
    outline: none;
    color: black;
    border-radius: 25px;
    padding: 10px;
    text-align: left;
  }
}

@media only screen and (max-width: 740px) {
  .btns-info {
    .btn {
      font-size: 10px;
    }
    .info {
      font-size: 10px;
    }
  }

  .locsearch-container {
    top: 65px;
    height: 30px;
    left: 10px;
    width: 60%;
    font-size: 13px;

    .icon-wrapper {
      width: 20%;
      height: 100%;
    }
    .button-icon {
      font-size: 15px;
    }

    .search-field {
      padding: 0px 5px;
    }
  }

  .locquery-container {
    top: 100px;
    left: 10px;
    max-height: 130px;
    height: "auto";
    width: 60%;
    font-size: 13px;

    .locquery-items {
      margin: 5px 5px;
    }
  }
}

.total-price {
  font-weight: 600;
  line-height: 22px;
}
</style>
